module.exports = __webpack_public_path__ + "img/4.d9c3a089.png";